<template>
<div>
  
  <button-caret :open="open" v-bind:title="title" v-on:click.native="toggleVisibility()"/>

  <transition name="folder" v-on:after-leave="transitionEnd" v-on:enter="transitionStart">
  <div v-show="open" class="folder-content" :style='{height:maxHeight}'>
    <div class="content-height" :key="updateKey" ref="contentHeight">
      <slot></slot>
    </div>
  </div>
  </transition>
  <div class="mb"></div>
  </div>
  
  
</template>

<script>
import ButtonCaret from './ButtonCaret.vue'


export default {
  name: 'fold-button',
  data:function(){
    return {
      open:false,
      height:"0px",
      maxHeight:"0px",
      updateKey:0,
    }
  },
  props:{
    title:{default:"no-title"}
  },
  components:{
    ButtonCaret,
  },
  computed:{
    
  },
  methods:{
    toggleVisibility(){
      // updating any contetn inside folder on open close
      
      this.$root.$emit('CLOSE_OPENED',{child:this});
      this.open=!this.open;
    },
    transitionEnd(){
      
    },
    transitionStart(){
      
      this.height=this.$refs.contentHeight.clientHeight+"px";
      
      
      if(this.updateKey!="refreshOnce"){
         this.updateKey="refreshOnce"
      }
       
      
    }
  },
  updated:function(){
    this.$nextTick(()=>{
      this.maxHeight=this.$refs.contentHeight.clientHeight+"px";
    })
    
   
   //this.height=;
  },
  mounted:function(){

    this.$root.$on('CLOSE_OPENED',(payload)=>{
      // close all others
      if(payload.child !== this){
        this.open=false;
      }
      
    })

    
    

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.mb{
  padding-bottom:10px;
}

.folder-content{
  overflow-y:hidden;
  position:relative;
  width:100%;
  border:1px solid #EEEEEE;
  border-radius:0 0 4px 4px;
  
  border-top:none;
}
.content-height{
  padding:10px;
}

/* background fading */
.folder-enter-active, .folder-leave-active{
  opacity:1;
  transition: height .35s,opacity .25s;
}
.folder-enter, .folder-leave-to /* .fade-leave-active below version 2.1.8 */ {
   opacity:0;
   height:0px!important;
}

</style>

